var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgIcAddUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97278 10.2964C11.1514 9.62179 11.9567 8.36568 11.9567 6.91312C11.9567 4.75543 10.2013 3 8.0436 3C5.88591 3 4.13048 4.75543 4.13048 6.91312C4.13048 8.36568 4.93579 9.62179 6.11442 10.2964C3.16631 11.0704 1 13.5631 1 16.5175V17.4785C1 17.6945 1.17532 17.8698 1.39132 17.8698C1.60733 17.8698 1.78265 17.6945 1.78265 17.4785V16.5175C1.78261 13.3799 4.59147 10.8262 8.0436 10.8262C11.4957 10.8262 14.3046 13.3799 14.3046 16.5175V17.4785C14.3046 17.6945 14.4799 17.8698 14.6959 17.8698C14.9119 17.8698 15.0872 17.6945 15.0872 17.4785V16.5175C15.0872 13.5631 12.9209 11.0696 9.97278 10.2964ZM4.91312 6.91312C4.91312 5.18667 6.31715 3.78265 8.0436 3.78265C9.77005 3.78265 11.1741 5.18667 11.1741 6.91312C11.1741 8.63957 9.77005 10.0436 8.0436 10.0436C6.31715 10.0436 4.91312 8.63961 4.91312 6.91312Z",
    fill: "#737373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2424 10.3067C16.0907 9.74559 16.6527 8.78608 16.6527 7.6959C16.6527 5.96945 15.2486 4.56543 13.5222 4.56543C13.3062 4.56543 13.1309 4.74075 13.1309 4.95675C13.1309 5.17276 13.3062 5.34808 13.5222 5.34808C14.8166 5.34808 15.8701 6.4015 15.8701 7.69594C15.8701 8.99038 14.8166 10.0438 13.5222 10.0438C13.3062 10.0438 13.1309 10.2191 13.1309 10.4351C13.1309 10.6511 13.3061 10.8264 13.5221 10.8264C16.1118 10.8264 18.2179 12.7728 18.2179 15.166V15.9134C18.2179 16.1294 18.3932 16.3047 18.6092 16.3047C18.8252 16.3047 19.0005 16.1294 19.0005 15.9134V15.166C19.0005 12.9042 17.4228 10.9829 15.2424 10.3067Z",
    fill: "#737373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddUser);
export default __webpack_public_path__ + "static/media/ic-add-user.8ebcfdb74311abfadf2980a7612b4453.svg";
export { ForwardRef as ReactComponent };